import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "adp-loading-dialog",
  templateUrl: "./adp-loading-dialog.component.html",
  styleUrls: ["./adp-loading-dialog.component.scss"],
})
export class adpLoadingDialogComponent implements OnInit, OnDestroy {
  constructor(
    public mdDialogRef: MatDialogRef<adpLoadingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    mdDialogRef.disableClose = true;
  }

  ngOnInit() {}

  public close(value) {
    this.mdDialogRef.close(value);
  }

  ngOnDestroy() {}
}
